import { lazyImport } from "@utils/lazy-import"

export default [
  {
    path: "/",
    name: "login",
    component: lazyImport(() => import("@views/LoginView.vue"))
  },
  {
    path: "/c/:token",
    sensitive: true,
    name: "login-token",
    component: lazyImport(() => import("@views/LoginTokenView.vue"))
  },
  {
    path: "/programari",
    name: "events",
    component: lazyImport(() => import("@views/EventsView.vue")),
    meta: { requiresAuth: true }
  },
  {
    path: "/abonamente",
    name: "subscriptions",
    component: lazyImport(() => import("@views/SubscriptionsView.vue")),
    meta: { requiresAuth: true }
  },
  {
    path: "/:token",
    sensitive: true,
    name: "login-token-short",
    component: lazyImport(() => import("@views/LoginTokenView.vue"))
  },

  {
    /**
     * Match all paths
     * uses /:pathMatch(.*)* or /:pathMatch(.*) or /:catchAll(.*)
     */
    path: "/:catchAll(.*)",
    redirect: { name: "route.notFound", replace: false }
  },
  {
    path: "/404",
    name: "route.notFound",
    component: lazyImport(() => import("@views/NotFound.vue"))
  }
]
